import firebase from "firebase"
import React, { useRef, useState } from "react"
import { Button, Card, Form, Spinner, Table } from "react-bootstrap"
import { db } from "../firebase"

export default class Profile extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            editMode: false
        }
        this.changeState = this.changeState.bind(this)
    }

    changeState() {
        console.log("changeState Called")
        this.setState({
            editMode: true
        })
    }

    render() {
        return (
            <div>
                {this.state.editMode ? <Edit></Edit> : <Display handler={this.changeState}></Display>}
            </div>
        )
    }
}


class Display extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            userProf: {
                displayName: "displayName",
                lname: "lname"
            }
        }
        this.getProfile = this.getProfile.bind(this)
    }

    getProfile() {
        this.setState({ loading: true })
        db.collection("appusers").where("uid", "==", firebase.auth().currentUser.uid)
            .get()
            .then((querySnapShot) => {
                var docs = querySnapShot.docs
                if (docs.length === 1) {
                    this.setState({ userProf: docs[0].data() })
                    console.log(docs)
                } else {
                    console.log(`expecting 1 document, but got ${docs.length}`)
                }

                this.setState({ loading: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    componentDidMount() {
        firebase.auth().onAuthStateChanged((user) => {
            this.getProfile()
        })
    }

    render() {
        return (
            <div>
                <Card style={{ maxWidth: "500px", margin: "auto", "margin-top": "10%", padding: "20px" }}>
                    <Card.Body>
                        {this.state.loading ? <Spinner style={{ margin: "auto" }} animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner> :
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Display Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>{this.state.userProf.displayName}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        }

                    </Card.Body>
                    {/* <Button 
                        style={{width: "100px", margin: "auto"}} 
                        onClick={this.props.handler}
                    >
                        Edit
                    </Button> */}
                </Card>
            </div>
        )
    }
}


function Edit() {
    var [loading, setLoading] = useState(true)
    var [doReload, setdoReload] = useState(false)
    var userProf = null

    function getProfile() {
        db.collection("appusers").where("uid", "==", firebase.auth().currentUser.uid)
            .get()
            .then((querySnapShot) => {
                var docs = querySnapShot.docs
                if (docs.length === 1) {
                    var doc = docs[0]
                    userProf = doc.id
                    console.log(doc.data())
                } else {
                    console.log(`expecting 1 document, but got ${docs.length}`)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    function handleSubmit(e) {
        e.preventDefault()

        setLoading(true)

        if (userProf) {
            var docRef = db.collection("appusers").doc(`${userProf}`)
            docRef.update({
                displayName: `${displayNameRef.current.value}`,
                uid: firebase.auth().currentUser.uid
            })
                .then(() => {
                    console.log("Profile updated")
                    setdoReload(true)
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            var docRef = db.collection("appusers").where("uid", "==", firebase.auth().currentUser.uid)
                .get()
                .then((querySnapshot) => {
                    var docs = querySnapshot.docs
                    if (docs.length == 1) {
                        var doc = docs[0]
                        doc.set({
                            displayName: `${displayNameRef.current.value}`,
                            uid: firebase.auth().currentUser.uid
                        })
                            .then(() => {
                                console.log("Profile saved")
                                setdoReload(true)
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })

        }
    }

    var displayNameRef = useRef()
    getProfile()

    const loadingScheme = (
        <div>
            <Spinner style={{ margin: "auto" }} animation="border" role="status">
                <span className="sr-only">Loading...</span>
            </Spinner>
        </div>
    )

    const editScheme = (
        <Card style={{ maxWidth: "350px", margin: "auto", "margin-top": "30px" }}>
            <Card.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Text className="text-muted">This name will be used as your player display name. You can not change it once you set it up.</Form.Text>
                    <Form.Group controlId="ControlFirstName">
                        <Form.Label>Display Name</Form.Label>
                        <Form.Control type="text" ref={displayNameRef} />
                    </Form.Group>
                    <Button type="submit">
                        Save changes
                    </Button>
                </Form>

            </Card.Body>
        </Card>
    )


    return (
        <div>
            {doReload ? window.location.reload() : loading ? loadingScheme : editScheme}

        </div>
    )
}